export class RegisterModel {
    userid: number;
    phone: string;
    email: string;
    fax: string;   
    preferreddelivery: string='';   
    attorneyCode: string;
    contactperson: string;
    firstName: string;
    firmName: string;
    lastName: string;
    password: string;
    confirmPassword: string;
};